@if (mostrarFab()) {
  <button
    type="button"
    class="chat-fab"
    (click)="abrirPanel()"
    aria-label="Abrir conversaciones de WhatsApp"
    title="Conversaciones de WhatsApp"
  >
    <i class="pi pi-comments" aria-hidden="true"></i>
    @if (totalNoLeidos() > 0) {
      <span class="chat-fab__badge">{{ totalNoLeidos() > 99 ? '99+' : totalNoLeidos() }}</span>
    }
  </button>

  <p-drawer
    [(visible)]="panelVisible"
    position="right"
    [style]="{ width: '420px', maxWidth: '95vw' }"
    appendTo="body"
    styleClass="chat-global-fab-panel"
  >
    <ng-template #header>
      <div class="chat-fab-panel__header">
        <i class="pi pi-comments" aria-hidden="true"></i>
        <span>Conversaciones</span>
      </div>
    </ng-template>

    @if (panelVisible()) {
      <app-chat-conversaciones-lista
        modo="panel"
        (conversacionAbierta)="onConversacionAbierta()"
      ></app-chat-conversaciones-lista>
    }
  </p-drawer>
}
